// The "This install" card at the foot of the changelog: which website build,
// Android app and timer firmware this person is running. Kept pure so the
// row logic is testable without the dialog, the native shell or the API.
import { compareSemver } from "./changelogVersions";

// Same board rule as useKhronosTimers' releasesForBoard (unmarked = the v2.0
// S3), restated here because that module pulls in the API and socket layers.
const boardOf = (x) => (x && x.board) || "s3-v20";
const releasesForBoard = (releases, device) =>
  releases.filter((r) => boardOf(r) === boardOf(device));

/**
 * @param {{ web: string, native?: {version: string, build?: string|null}|null,
 *           devices?: Array<{id: any, name?: string, firmware_version?: string, board?: string}>,
 *           releases?: Array<{version: string, board?: string}> }} input
 * @returns {Array<{key: string, label: string, version: string, note: string|null}>}
 */
export function buildInstallRows({ web, native = null, devices = [], releases = [] }) {
  const rows = [{ key: "web", label: "Website", version: web, note: null }];

  if (native && native.version) {
    rows.push({
      key: "android",
      label: "Android app",
      version: native.version,
      note: native.build ? `build ${native.build}` : null,
    });
  }

  const timers = (devices || []).filter((d) => d && d.firmware_version);
  timers.forEach((device) => {
    const latest = releasesForBoard(releases || [], device)[0];
    let note = null;
    if (latest) {
      note =
        compareSemver(latest.version, device.firmware_version) < 0
          ? `v${latest.version} available`
          : "up to date";
    }
    rows.push({
      key: `timer-${device.id}`,
      // One timer reads as "Timer"; several need their names to tell apart.
      label: timers.length > 1 ? device.name || "Timer" : "Timer",
      version: device.firmware_version,
      note,
    });
  });

  return rows;
}
